import AllhomesAgentMobileCta from './allhomes-agent-mobile-cta';
export default AllhomesAgentMobileCta;